/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import SecureLS from 'secure-ls';
import { useForm } from 'react-hook-form';
import {
  InputBox,
  PasswordInput,
  Checkbox,
  Button,
} from '../../components/Form';
import { useSelector, useDispatch } from 'react-redux';
import InlineError from '../../components/ErrorComponents/InlineError';
import ResetPassword from '../../components/ResetPassword';
import LockedAccount from '../../components/ErrorComponents/LockedAccount';
import Spinner from '../../components/Spinner';
import CookieBanner from '../../components/CookieBanner';
import { BalanceIcon } from '../../assets/svg/StatusIcon';
import {
  AppDispatch,
  signInRequest,
  initializeStoredUser,
  updateSession,
  encryptAES,
  RootState,
  getChannelId,
  signOutRequest,
  resetUser,
  resetValidatePasscodeSlice,
  resolvePasskeyFeatureFlags,
} from '@rb-serve-app/core';
import { EventType, useAnalytics } from '../../ui/Analytics';
import { useSecureDeviceId, useRecaptchaToken } from '@rb-serve-app/core';
import FeatureFlagMessage from '../../components/FeatureFlagMessage';
import VerifyIdentityModal from '../../components/VerifyIdentityModal';
import { environment } from '@rb-serve-app/core';
import { useSearchParams } from 'react-router-dom';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import PWAInstallModal from '../../PWAInstallModal';
import { usePWAInstall } from '../../usePWAInstall';
import { usePasskeySignIn } from './usePasskeySignIn';
import {
  AuthFallbackReason,
  AuthMethod,
  evaluateAuthMethod,
  isPasskeyLaunchWindowActive,
  isPasskeyTerminalMwError,
} from './evaluateAuthMethod';
import {
  getPasskeyHintStatus,
  setPasskeyHintPresent,
} from './passkeyDeviceHint';
// import LocalStorageDebug from '../../LocalStorageDebug';

type FormValues = {
  username: string;
  password: string;
  rememberMe: boolean;
};
interface LoginError {
  status: any;
  errorMsg: string | null;
}
const SignIn: React.FC = () => {
  const {
    register,
    handleSubmit,
    setValue,
    resetField, // used to clear the username input
    formState: { errors },
    watch,
    setError,
    clearErrors,
  } = useForm<FormValues>({ mode: 'onChange' });
  const deviceId = useSecureDeviceId() || '';

  const dispatch = useDispatch();
  const AppDispatch: AppDispatch = useDispatch();
  const register_forgotUrl = environment?.webregisterUrl;
  //integration
  const {
    loading,
    error,
    statusCode,
    accountDetailsError,
    passkeyError: passkeyMwError,
    passkeyStatusCode,
  } = useSelector((state: any) => state?.user);
  const {
    isValidatePasscodeLoading,
    isValidatePasscodeError,
    validationPasscode,
  } = useSelector((state: RootState) => state.validatePasscode);

  const { rewards } = useSelector((state: any) => state?.rewards);
  const { shouldShow, mode, remindLater, dismiss, isStandaloneMode } =
    usePWAInstall();

  //end

  const [storedUsername, setStoredUsername] = useState<string | null>(null);
  const usernameValue = watch('username', '');
  const passwordValue = watch('password', '');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLockedModal, setIsLockedModal] = useState(false);
  const [iscoorpUserModal, setIscoorpUserModal] = useState(false);
  const [, setIsUsernameTouched] = useState(false);
  const [currentUsername, setCurrentUsername] = useState<string | null>(null);
  const [loginError, setLoginError] = useState<LoginError>({
    status: null,
    errorMsg: null,
  });
  const [accountDetailError, setAccountDetailError] = useState({
    status: null,
    errorMsg: null,
  });

  const [isOpenOtpModal, setIsOpenOtpModal] = useState(false);
  const [requestData, setRequestData] = useState({});
  const [currentModal, setCurrentModal] = useState<
    'VERIFY_IDENTITY' | 'VERIFICATION_CODE' | null
  >(null);
  // const ls = new SecureLS({ encodingType: 'aes', isCompression: false });
  const ls = useMemo(
    () => new SecureLS({ encodingType: 'aes', isCompression: false }),
    []
  );
  const { isSessionTimeout, userName, isAuthenticated } = useSelector(
    (state: any) => state.user
  );
  // const { rememberMe } = useSelector((state: any) => state.user);

  const [inactivityErrorMsg, setInactivityErrorMsg] = useState<string | null>(
    null
  );
  const [showFeatureFlagMessage, setShowFeatureFlagMessage] = useState(false);
  const [usePasswordToLogin, setUsePasswordToLogin] = useState(false);
  const [isSignInLocked, setIsSignInLocked] = useState(false);

  const skipPasskeyThisSessionRef = useRef(false);
  const authMethodInFlightRef = useRef<AuthMethod | null>(null);
  const authMethodUsedRef = useRef<AuthMethod>('password');
  const passwordInputRef = useRef<HTMLInputElement | null>(null);
  const usernameInputRef = useRef<HTMLInputElement | null>(null);
  const hasHydratedRememberedRef = useRef(false);

  const { trackEvent } = useAnalytics();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const passkeyFeatureFlagging = useSelector(
    (state: RootState) =>
      state.contentful?.contentfulData?.entries?.rb_feature_flagging
        ?.featureFlagging
  );
  const webPasskeyFlags = resolvePasskeyFeatureFlags(passkeyFeatureFlagging).web;
  const passwordStep = webPasskeyFlags.retroSignInUi || usePasswordToLogin;
  const allowPasskeySdk =
    webPasskeyFlags.sdkEnabled &&
    !webPasskeyFlags.retroSignInUi &&
    !webPasskeyFlags.bypassPasskeySignIn;

  const {
    isPasskeySupported,
    isPasskeyLoading,
    passkeyError,
    passkeyStatusCode: passkeyHookStatusCode,
    clearPasskeyError,
    handlePasskeySignIn,
  } = usePasskeySignIn({
    isPasswordLoading: loading,
    allowPasskeySdk,
    passUsernameToTransmit: webPasskeyFlags.passUsernameToTransmit,
  });

  useEffect(() => {
    trackEvent(
      EventType.PAGE_VIEW,
      'signin',
      '/sign-in',
      undefined,
      false,
      {},
      undefined,
      true,
      {
        type: 'remember me',
        name: ls.get('rememberedUsername') ? 'yes' : 'no',
      }
    );
  }, []);

  useEffect(() => {
    if (
      isValidatePasscodeError?.statusCode == 401 &&
      isValidatePasscodeError?.error?.errCode == 'COORP_401_USER_ERROR'
    ) {
      setIsOpenOtpModal(false);
      setIscoorpUserModal(true);
      setCurrentModal(null);
    }
  }, [isValidatePasscodeError]);

  useEffect(() => {
    if (passkeyMwError?.errCode === 'COORP_401_USER_ERROR') {
      setIsOpenOtpModal(false);
      setIscoorpUserModal(true);
      setCurrentModal(null);
    }
    if (passkeyMwError?.errCode === 'ERR_401_ACCOUNT_LOCKED') {
      setIsLockedModal(true);
    }
  }, [passkeyMwError]);

  useEffect(() => {
    if (hasHydratedRememberedRef.current) {
      return;
    }
    hasHydratedRememberedRef.current = true;
    try {
      const storedUsername = ls.get('rememberedUsername');
      if (storedUsername) {
        setStoredUsername(storedUsername);
        setValue('username', maskUsername(storedUsername));
        setValue('rememberMe', true);
      }
    } catch (error) {
      console.error('Error retrieving remembered username:', error);
      ls.remove('rememberedUsername');
      setStoredUsername(null);
      setValue('username', '');
      setValue('rememberMe', false);
    }
  }, [ls, setValue]);

  useEffect(() => {
    AppDispatch(initializeStoredUser());
  }, [AppDispatch]);

  useEffect(() => {
    if (accountDetailsError) {
      setIsOpenOtpModal(false);
      setCurrentModal(null);
      setAccountDetailError({
        status: accountDetailsError?.errCode,
        errorMsg: entries?.rb_view_statements?.apiFailureBannerMsg,
      });
    } else {
      setAccountDetailError({ status: null, errorMsg: null });
    }
  }, [accountDetailsError]);

  useEffect(() => {
    if ([500, '500'].includes(statusCode)) {
      setLoginError({
        status: 500,
        errorMsg:
          entries.rb_signin.siginErrorCodes?.ERR_503_SVC_NOT_AVAIL?.description,
      });
    }
    if (statusCode === '401' && error?.errCode === 'ERR_401_ACCOUNT_LOCKED') {
      setIsLockedModal(true);
    } else if (
      error?.statusCode === 401 &&
      error?.errCode === 'COORP_401_USER_ERROR'
    ) {
      setIsOpenOtpModal(false);
      setIscoorpUserModal(true);
    } else if (
      ['400', '401', '404', '503'].includes(statusCode) &&
      error?.errCode !== 'ERR_401_ACCOUNT_LOCKED'
    ) {
      if (error?.errCode === 'Bad Request') {
        setLoginError({
          status: 'BAD_REQUEST',
          errorMsg:
            entries.rb_signin.siginErrorCodes?.ERR_503_SVC_NOT_AVAIL
              ?.description,
        });
      } else {
        setLoginError({
          status: error?.errCode,
          errorMsg: error?.msg,
        });
      }
    } else {
      if (statusCode == '412' && error?.errCode !== 'ERR_401_ACCOUNT_LOCKED') {
        setLoginError({
          status: error?.errCode,
          errorMsg: error?.msg,
        });
        setIsOpenOtpModal(true);
        setCurrentModal('VERIFY_IDENTITY');
      } else {
        setLoginError({
          status: 404,
          errorMsg:
            entries.rb_signin.siginErrorCodes?.ERR_503_SVC_NOT_AVAIL
              ?.description,
        });
        setIsLockedModal(false);
      }
    }

    if (['400', '401', '404', '503', '500', 500].includes(statusCode)) {
      trackEvent(
        EventType.PAGE_VIEW,
        'signin',
        globalThis.location.href,
        'click',
        false,
        {},
        {
          category: 'login',
          type: 'user',
          code: error?.errCode,
          API: 'sign_in',
          field: '',
          message: error?.msg,
        }
      );
    }
  }, [error, statusCode]);

  useEffect(() => {
    try {
      const userDetails = ls.get('user');
      if (userDetails) {
        setLoginError((prev) => ({ ...prev, status: null, errorMsg: null }));
      }
    } catch (error) {
      console.error('Error reading user from secureLS:', error);
      setLoginError((prev) => ({
        ...prev,
        status: true,
        errorMsg: 'Failed to load user data',
      }));
    }
  }, [ls]);

  const closeModal = () => {
    setIsModalOpen(false);
    setIsLockedModal(false);
    setIsUsernameTouched(false);
    setIsOpenOtpModal(false);
    setIscoorpUserModal(false);
    clearPasskeyError();
  };

  const showFeatureLocked = () => {
    if (globalThis.scrollY !== 0) {
      globalThis.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
    setIsLockedModal(false);

                  trackEvent(
                    EventType.CLICK_EVENT,
                    'signin',
                    globalThis.location.href,
                    'signin|forgot username or password?'
                  );
                  
                  const language = localStorage?.getItem('language');
                  const params = language == 'fr' ? 'fr_CA' : 'en_CA';
                  globalThis.open(
                    `${register_forgotUrl}?locale=${params}&product=ROGERSBRAND`,
                    '__blank',
                    'noopener,noreferrer'
                  );
                  
                    !featureFlaggingData?.sign_in?.forgot_password &&
                      setShowFeatureFlagMessage(true);
                    setTimeout(() => {
                      setShowFeatureFlagMessage(false);
                    }, 3000);
                  
               
   
  };

  useEffect(() => {
    setLoginError({ status: null, errorMsg: null });
    if (passwordValue) {
      const passwordPattern = /^(?=.*[0-9])(?=.*[a-zA-Z]).{8,20}$/;
      if (!passwordPattern.test(passwordValue)) {
        setError('password', {
          type: 'pattern',
          message: signInContentfulldata?.passwordErrorText,
        });
      } else {
        clearErrors('password');
      }
    }
  }, [passwordValue, setError, clearErrors]);
  const [selectedLanguage, setSelectedLanguage] = useState('en-US');

  useEffect(() => {
    setLoginError({ status: null, errorMsg: null });
  }, [usernameValue, passwordValue]);

  const { contentfulData } = useSelector(
    (state: { contentful: any }) => state.contentful
  );
  const { entries, assets } = contentfulData;
  const { rb_signin, rb_common } = entries;
  const signInContentfulldata = entries?.rb_signin;
  const sessionTimeMsg = entries?.rb_session_flow;
  const [preNotificationBanner, setPreNotificationBanner] = useState(false);
  const [searchParams] = useSearchParams();
  const locale = searchParams.get('locale');
  const featureFlaggingData = entries?.rb_feature_flagging?.featureFlagging;
  console.log('featureFlaggingData', featureFlaggingData);
  const getRecaptchaToken = useRecaptchaToken();
  const { siginErrorCodes } = signInContentfulldata
    ? signInContentfulldata
    : '';

  useEffect(() => {
    const storedUsername = ls.get('rememberedUsername');
    setCurrentUsername(storedUsername);
  }, [ls]);

  const handleClickEvent = (action: string) => {
    trackEvent(
      EventType.CLICK_EVENT,
      'signin',
      globalThis.location.href,
      `signin | ${action}`
    );
  };

  function maskUsername(username: string) {
    if (username.length <= 4) {
      return username;
    }
    const visibleStart = 2;
    const visibleEnd = 2;
    const maskLength = username.length - visibleStart - visibleEnd;
    const maskedPart = '*'.repeat(maskLength);
    return (
      username.slice(0, visibleStart) + maskedPart + username.slice(-visibleEnd)
    );
  }
  const handleUsernameChange = (e: any) => {
    setLoginError({ status: null, errorMsg: null });
    const value = e.target.value;
    setIsUsernameTouched(true);

    if (value == '') {
      // setValue('username', storedUsername || '');
      setValue('username', '');
      setCurrentUsername(storedUsername || null);
    } else {
      if (value.includes('*')) {
        const uName = maskUsername(storedUsername || '');
        if (uName) {
          setValue('username', uName);
        }
        setCurrentUsername(storedUsername || null);
      } else {
        setValue('username', value);
        setCurrentUsername(value);
      }
    }
  };

  const resolveEnteredUsername = (): string => {
    const liveValue = (
      usernameInputRef.current?.value ??
      usernameValue ??
      ''
    ).trim();

    if (liveValue && !liveValue.includes('*')) {
      return liveValue;
    }
    return (currentUsername || storedUsername || '').trim();
  };

  const applyResolvedUsername = (resolved: string): string => {
    if (!resolved) {
      return resolved;
    }
    const liveValue = (
      usernameInputRef.current?.value ??
      usernameValue ??
      ''
    ).trim();
    if (liveValue && !liveValue.includes('*')) {
      setValue('username', resolved);
      setIsUsernameTouched(true);
    }
    setCurrentUsername(resolved);
    return resolved;
  };

  const resolvedPasskeyUsername = resolveEnteredUsername();

  const persistRememberedUsername = (
    rememberMe: boolean,
    resolvedUsername: string
  ) => {
    if (rememberMe && resolvedUsername) {
      ls.set('rememberedUsername', resolvedUsername.trim());
    } else if (rememberMe && storedUsername) {
      ls.set('rememberedUsername', storedUsername.trim());
    } else {
      ls.remove('rememberedUsername');
    }
  };

  const revealPasswordField = () => {
    applyResolvedUsername(resolveEnteredUsername());
    authMethodInFlightRef.current = null;
    authMethodUsedRef.current = 'password';
    setIsSignInLocked(false);
    setUsePasswordToLogin(true);
    setValue('password', '');
    clearErrors('password');
  };

  const continueWithNextAuthMethod = (reason: AuthFallbackReason) => {
    skipPasskeyThisSessionRef.current = true;
    authMethodInFlightRef.current = null;
    trackEvent(
      EventType.CLICK_EVENT,
      'signin',
      window.location.href,
      `auth-method-fallback:${reason}`
    );
    revealPasswordField();
  };

  const startSelectedAuthMethod = async (method: AuthMethod) => {
    authMethodUsedRef.current = method;
    authMethodInFlightRef.current = method;
    trackEvent(
      EventType.CLICK_EVENT,
      'signin',
      window.location.href,
      `auth-method-selected:${method}`
    );

    if (method === 'password') {
      revealPasswordField();
      return;
    }

    setIsSignInLocked(true);
    const result = await handlePasskeySignIn(resolveEnteredUsername());
    if (result.kind === 'submitted') {
      return;
    }
    if (result.kind === 'cancelled') {
      continueWithNextAuthMethod('user_cancel');
      return;
    }
    if (result.kind === 'unavailable') {
      continueWithNextAuthMethod('no_credential');
      return;
    }
    if (result.kind === 'check_failed' || result.kind === 'blocked') {
      continueWithNextAuthMethod('check_error');
      return;
    }
    if (result.kind === 'failed') {
      continueWithNextAuthMethod('sdk_error');
    }
  };

  const evaluateAndStartAuth = async () => {
    if (isSignInLocked || isPasskeyLoading || loading) {
      return;
    }

    setIsSignInLocked(true);
    clearPasskeyError();

    try {
      const launchEnabled = isPasskeyLaunchWindowActive(
        featureFlaggingData?.sign_in
      );
      const passkeyHint = await getPasskeyHintStatus(resolveEnteredUsername());
      const method = evaluateAuthMethod({
        skipPasskeyThisSession: skipPasskeyThisSessionRef.current,
        isPasskeyLaunchEnabled: launchEnabled,
        isPasskeySupported,
        passkeyHint,
        bypassPasskey: webPasskeyFlags.bypassPasskeySignIn,
      });

      if (!launchEnabled && method !== 'passkey') {
        trackEvent(
          EventType.CLICK_EVENT,
          'signin',
          window.location.href,
          'auth-method-fallback:launch_window'
        );
      }

      await startSelectedAuthMethod(method);
    } catch (error) {
      console.warn('[SignIn] Auth method evaluation failed:', error);
      continueWithNextAuthMethod('check_error');
    }
  };

  const handleSignIn = async (inputValues: any, resolvedUsername: string) => {
    persistRememberedUsername(inputValues.rememberMe, resolvedUsername);

    const token = await getRecaptchaToken('sign_in');
    console.log('Recaptcha token signin:', token);
    const inputData = {
      username: resolvedUsername.trim(),
      password: encryptAES(inputValues.password?.trim()),
      deviceId: deviceId,
      channel: getChannelId,
      flow: 'PATH_AUTH_API',
      recaptchaToken: token,
    };
    const data = {
      apiName: 'sign_in',
      data: inputData,
    };
    setRequestData(data);
    dispatch(signInRequest(data));
  };

  const onFormSubmit = async (inputValues: FormValues) => {
    const resolvedUsername = applyResolvedUsername(resolveEnteredUsername());
    persistRememberedUsername(inputValues.rememberMe, resolvedUsername);
    if (passwordStep) {
      await handleSignIn(inputValues, resolvedUsername);
      return;
    }
    await evaluateAndStartAuth();
  };

  useEffect(() => {
    if (authMethodInFlightRef.current !== 'passkey') {
      return;
    }
    if (!passkeyMwError) {
      return;
    }
    if (isPasskeyTerminalMwError(passkeyMwError)) {
      authMethodInFlightRef.current = null;
      setIsSignInLocked(false);
      return;
    }
    skipPasskeyThisSessionRef.current = true;
    revealPasswordField();
  }, [passkeyMwError]);

  useEffect(() => {
    if (
      authMethodUsedRef.current === 'passkey' &&
      (passkeyStatusCode === '200' || passkeyHookStatusCode === '200') &&
      resolvedPasskeyUsername
    ) {
      void setPasskeyHintPresent(resolvedPasskeyUsername);
    }
  }, [passkeyStatusCode, passkeyHookStatusCode, resolvedPasskeyUsername]);

  useEffect(() => {
    if (passwordStep) {
      passwordInputRef.current?.focus();
    }
  }, [passwordStep]);

  useEffect(() => {
    if (isSessionTimeout) {
      const message = sessionTimeMsg?.sessionTimeoutInactivityErrorContent;
      setInactivityErrorMsg(message);
      setTimeout(() => {
        dispatch(updateSession());
        setInactivityErrorMsg(null);
      }, 3000);
    }
  }, [isSessionTimeout]);

  useEffect(() => {
    if (rewards) {
      ls.set('isAuthenticate', 'true');
    }
  }, [ls, rewards]);
  useEffect(() => {
    const storedLanguage = localStorage.getItem('language') || 'en-US';
    setSelectedLanguage(storedLanguage);
  }, []);

  const handleLanguageChange = () => {
    const newLanguage = selectedLanguage == 'en-US' ? 'fr' : 'en-US';
    setSelectedLanguage(newLanguage);
    const lang = newLanguage == 'fr' ? 'fr' : 'en';
    localStorage.setItem('language', newLanguage);
    console.log(`Language changed to: ${newLanguage}`);
    const nextParam = searchParams.get('next');
    const params = new URLSearchParams({ locale: lang });
    if (nextParam) {
      params.set('next', nextParam);
    }
    globalThis.location.href = `/sign-in?${params.toString()}`;
  };
  const handlePreBanner = () => {
    localStorage.setItem('preLoginNotificationBannerVisible', 'false');
    setPreNotificationBanner(false);
  };
  useEffect(() => {
    setPreNotificationBanner(
      entries?.rb_banner?.bannerVisibility?.preLoginNotificationBanner_web
    );
    if (localStorage.getItem('preLoginNotificationBannerVisible') == 'false') {
      setPreNotificationBanner(false);
    }
  }, []);

  useEffect(() => {
    const locale = searchParams.get('locale'); // ensure this matches the URL
    const nextParam = searchParams.get('next');
    const params = new URLSearchParams();
    const normalizedLocale = locale === 'en' || locale === 'fr' ? locale : 'en';

    if (locale === 'en' || locale === 'fr') {
      const lang = locale == 'fr' ? 'fr' : 'en-US';
      localStorage.setItem('language', lang);
      setSelectedLanguage(lang);
    } else {
      localStorage.setItem('language', 'en-US');
      setSelectedLanguage('en-US');
    }

    params.set('locale', normalizedLocale);
    if (nextParam) {
      params.set('next', nextParam);
    }

    const newUrl = `/sign-in?${params.toString()}`;

    if (
      globalThis.location.pathname + globalThis.location.search !==
      newUrl
    ) {
      globalThis.location.href = newUrl;
    }
  }, []);

  // Handle complete logout - following React Native pattern
  const logout = useCallback(
    async (reason = 'Unknown') => {
      console.log(`Logging out due to: ${reason}`);
      if (!isAuthenticated) return;

      // Prepare logout API data before resetting user state
      const deviceId = localStorage.getItem('deviceId');
      const userData = {
        username: userName, // Get userName before reset
        deviceId,
        channel: getChannelId,
        flow: 'PATH_SIGNOUT_API',
      };

      try {
        // Make logout API call first
        await dispatch(signOutRequest({ apiName: 'sign_out', data: userData }));
        console.log('Logout API call completed');
      } catch (error) {
        console.error('Logout API call failed:', error);
        // Continue with logout process even if API fails
      } finally {
        // Reset User data after API call
        dispatch(resetUser());
        dispatch(resetValidatePasscodeSlice());

        // Clear storage — tokens/user are cleaned by the signOutSaga after the API call
        localStorage.removeItem('sco');

        globalThis.location.reload();
        // window.location.href = '/sign-in';
      }
    },
    [dispatch, userName]
  );

  const continueTitle = rb_common?.commonString?.continue || 'Continue';
  const ctaTitle = passwordStep
    ? signInContentfulldata?.signinCtaTitle
    : continueTitle;
  const isAuthBusy = isSignInLocked || isPasskeyLoading || loading;
  const passwordRules = passwordStep
    ? {
        required: signInContentfulldata?.passwordErrorText,
        pattern: {
          value: /^(?=.*[0-9])(?=.*[a-zA-Z]).{8,20}$/,
          message: signInContentfulldata?.passwordErrorText,
        },
      }
    : {};
  const {
    ref: rhfUsernameRef,
    onChange: rhfUsernameChange,
    onBlur: rhfUsernameBlur,
    ...usernameRegister
  } = register('username', { required: 'Username is required' });
  const { ref: rhfPasswordRef, ...passwordRegister } = register(
    'password',
    passwordRules
  );

  return signInContentfulldata ? (
    <div>
      {showFeatureFlagMessage && <FeatureFlagMessage />}
      <header className="xl:hidden lg:hidden md:hidden flex bg-primary-red text-white justify-between md:flex-row items-center p-4">
        <div className="flex items-start">
          <img
            src={assets?.rb_logo_white}
            alt="Rogers Bank logo"
            width={208}
            height={26}
          />
        </div>
        <div className="cursor-pointer hover:underline">
          <button
            type="button"
            className="text-xl text-white w-auto"
            aria-label="Language selection"
            onClick={handleLanguageChange}
          >
            {selectedLanguage == 'fr'
              ? entries?.rb_header?.englishTitle
              : entries?.rb_header?.frenchTitle}
          </button>
        </div>
      </header>

      <div className="hidden md:flex justify-end p-10  hover:underline">
        <button
          type="button"
          className="text-lg text-primary-red hover:underline cursor-pointer"
          aria-label="Language selection"
          onClick={handleLanguageChange}
        >
          {selectedLanguage === 'fr'
            ? entries?.rb_header?.englishTitle
            : entries?.rb_header?.frenchTitle}
        </button>
      </div>

      <div className="flex justify-center items-start bg-text-white w-auto p-8 min-h-[73vh]">
        <form
          onSubmit={handleSubmit(onFormSubmit)}
          className="w-full max-w-[470px] bg-white flex gap-7 flex-col"
          noValidate
          aria-live="polite"
        >
          <div className="hidden md:flex justify-center items-center">
            <img
              src={assets?.RogersLogo}
              alt="Rogers-logo"
              className="xl:w-[420px] xl:h-[51px] lg:w-[250px] lg:h-[30px] md:w-[300px] md:h-[36px] "
            />
          </div>
          <h2 className="text-xl font-medium md:text-center text-gray-700 sm:text-left">
            {signInContentfulldata?.signinTitle}
          </h2>
          {preNotificationBanner && (
            <InlineError
              bannerText={entries?.rb_banner?.webPreLoginText}
              aria-live="assertive"
              fontSize={'text-[15px]'}
              onClose={() => handlePreBanner()}
              oncloseHide={true}
              banner={true}
              error={false}
            />
          )}
          {inactivityErrorMsg && (
            <InlineError
              errorText={inactivityErrorMsg}
              aria-live="assertive"
              fontSize={'text-[11px]'}
              onClose={() => setInactivityErrorMsg(null)}
            />
          )}
          {['400', '401', '404', '503', '500', 500].includes(statusCode) &&
            loginError.errorMsg !== null &&
            loginError.errorMsg !== undefined && (
              <InlineError
                errorText={
                  statusCode === '412' || statusCode == 500
                    ? loginError.errorMsg
                    : siginErrorCodes[`${loginError?.status}`]?.description
                }
                onClose={() =>
                  setLoginError({
                    status: null,
                    errorMsg: null,
                  })
                }
                aria-live="assertive"
                fontSize={statusCode === '412' ? 'text-[11px]' : 'text-text15'}
              />
            )}

          {/* // on click of reload it will call account details api again and if it fails then show error message in banner
// otherwise remove the banner and show the details in respective screens whereever its required. */}

          {accountDetailError?.errorMsg !== null && (
            <div className="flex  justify-center gap-[3%] items-start px-[15px] py-[10px] bg-[#FFF6F3]">
              <div className="flex items-center gap-[20px]">
                {' '}
                <div className="flex-shrink-0">
                  <img
                    src={assets?.infoToolTip}
                    alt="info-icon"
                    className="w-6 h-6"
                  />
                </div>
                <p className="text-[#5B1C00] text-base font-medium">
                  {accountDetailError?.errorMsg}
                </p>
              </div>
              <div className="flex-grow"></div>
              <button
                type="button"
                className="text-[#DA291C] text-base font-bold cursor-pointer"
                onClick={() => logout()}
              >
                {entries?.rb_rewards?.webErrorModal?.reload}
              </button>
              <button
                type="button"
                className="w-6 h-6 cursor-pointer"
                aria-label="Close account details error"
                onClick={() => {
                  setAccountDetailError({
                    status: null,
                    errorMsg: null,
                  });
                  handleClickEvent('reload');
                }}
              >
                <img
                  src={assets?.closeIcon}
                  alt="close-icon"
                  className="w-6 h-6"
                />
              </button>
            </div>
          )}

          <InputBox
            label={signInContentfulldata?.usernameTitle}
            type="text"
            ariaLabel={signInContentfulldata?.usernamePlaceholder}
            placeHolder={signInContentfulldata?.usernamePlaceholder}
            autoComplete="username"
            error={errors.username?.message}
            {...usernameRegister}
            ref={(el) => {
              rhfUsernameRef(el);
              usernameInputRef.current = el;
            }}
            onClear={() => {
              resetField('username');
              resetField('password');
            }}
            showClearButton={usernameValue?.trim().length > 0 ? true : false}
            onChange={(e) => {
              rhfUsernameChange(e);
              handleUsernameChange(e);
            }}
            onInput={handleUsernameChange}
            onBlur={(e) => {
              rhfUsernameBlur(e);
              handleUsernameChange(e);
            }}
          />

          {passwordStep && (
            <div aria-live="polite">
              <PasswordInput
                label={signInContentfulldata?.passwordTitle}
                ariaLabel={signInContentfulldata?.passwordPlaceholder}
                placeHolder={signInContentfulldata?.passwordPlaceholder}
                autoComplete="off"
                error={
                  errors.password?.message && (
                    <span className="flex items-center gap-[7px]">
                      <BalanceIcon fill="#DA291C" />
                      {errors.password?.message}
                    </span>
                  )
                }
                {...passwordRegister}
                ref={(el) => {
                  rhfPasswordRef(el);
                  passwordInputRef.current = el;
                }}
                showClearButton={!!passwordValue}
              />
            </div>
          )}
          <div className="flex justify-between flex-col md:flex-row">
            <Checkbox
              label={signInContentfulldata?.rememberMeTitle}
              ariaLabel={signInContentfulldata?.rememberMeTitle}
              {...register('rememberMe')}
              onChange={() =>
                trackEvent(
                  EventType.CLICK_EVENT,
                  'signin',
                  globalThis.location.href,
                  'signin|remember me'
                )
              }
            />
            <div
              className={`text-text16 font-[500] cursor-pointer focus:underline mt-[22px] md:mt-0 ${featureFlaggingData?.sign_in?.forgot_password ? 'text-primary-red' : 'text-gray-300'}`}
            >
              <button
                type="button"
                className="cursor-pointer border-0 bg-transparent p-0 text-inherit"
                onClick={() => {
                  trackEvent(
                    EventType.CLICK_EVENT,
                    'signin',
                    globalThis.location.href,
                    'signin|forgot username or password?'
                  );
                  if (globalThis.scrollY !== 0) {
                    globalThis.scrollTo({
                      top: 0,
                      behavior: 'smooth',
                    });
                  }
                  const language = localStorage?.getItem('language');
                  const params = language == 'fr' ? 'fr_CA' : 'en_CA';
                  globalThis.open(
                    `${register_forgotUrl}?locale=${params}&product=ROGERSBRAND`,
                    '__blank',
                    'noopener,noreferrer'
                  );
                  {
                    !featureFlaggingData?.sign_in?.forgot_password &&
                      setShowFeatureFlagMessage(true);
                    setTimeout(() => {
                      setShowFeatureFlagMessage(false);
                    }, 3000);
                  }
                }}
              >
                {signInContentfulldata?.forgotUsernamePasswordTitle}
              </button>
            </div>
          </div>
          {passkeyError && (
            <InlineError
              errorText={passkeyError.msg}
              aria-live="assertive"
              fontSize={'text-[11px]'}
              onClose={clearPasskeyError}
            />
          )}
          <div className="relative">
            <Button
              text={isAuthBusy ? '' : ctaTitle}
              aria-label={ctaTitle}
              disabled={
                !usernameValue.trim() ||
                isAuthBusy ||
                (passwordStep &&
                  (!passwordValue.trim() || !!errors.password))
              }
              loader={isAuthBusy}
              aria-busy={isAuthBusy}
              onClick={() =>
                trackEvent(
                  EventType.CLICK_EVENT,
                  'signin',
                  window.location.href,
                  passwordStep ? 'signin|signin' : 'signin|continue',
                  false,
                  undefined,
                  undefined,
                  false,
                  {},
                  false,
                  false,
                  {},
                  false,
                  true
                )
              }
            />
            {isAuthBusy && (
              <div className="flex justify-center items-center absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <div
                  role="status"
                  aria-live="polite"
                  className="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-6 w-6"
                ></div>
              </div>
            )}
          </div>
          <h1
            className="ml-2 block text-text16 font-medium text-[#1f1f1f] mb-[-15px] text-left md:text-center"
            aria-label="New user register"
          >
            {signInContentfulldata?.registerTitle}
          </h1>
          <button
            type="button"
            className={`min-h-[48px] w-full h-10 bg-white font-medium py-2 px-4 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 border border-1  ${featureFlaggingData?.sign_in?.register ? 'text-primary-red border-primary-red hover:bg-red-50' : 'text-gray-300'}`}
            aria-label={signInContentfulldata?.registerCtaTitle}
            onClick={() => {
              trackEvent(
                EventType.CLICK_EVENT,
                'sign in',
                globalThis.location.href,
                'sign in|register now'
              );
              if (globalThis.scrollY !== 0) {
                globalThis.scrollTo({
                  top: 0,
                  behavior: 'smooth',
                });
              }
              const language = localStorage?.getItem('language');
              const params = language == 'fr' ? 'fr_CA' : 'en_CA';
              globalThis.open(
                `${register_forgotUrl}?locale=${params}&product=ROGERSBRAND`,
                '__blank',
                'noopener,noreferrer'
              );
              {
                !featureFlaggingData?.sign_in?.register &&
                  setShowFeatureFlagMessage(true);
                setTimeout(() => {
                  setShowFeatureFlagMessage(false);
                }, 3000);
              }
            }}
          >
            {signInContentfulldata?.registerCtaTitle}
          </button>
        </form>
      </div>

      {isModalOpen && (
        <ResetPassword isOpen={isModalOpen} onClose={closeModal} />
      )}
      {(isLockedModal || iscoorpUserModal) && (
        <LockedAccount
          isOpen={isLockedModal || iscoorpUserModal}
          onClose={closeModal}
          showFeatureLocked={showFeatureLocked}
          coorpUser={iscoorpUserModal}
        />
      )}
      {isOpenOtpModal && currentModal && currentModal == 'VERIFY_IDENTITY' && (
        <VerifyIdentityModal
          userData={requestData}
          currentModal={currentModal}
          setIscoorpUserModal={setIscoorpUserModal}
          coorpUser={iscoorpUserModal}
        />
      )}

      <CookieBanner />
      <PWAInstallModal
        open={shouldShow}
        mode={mode}
        onRemindLater={remindLater} // Shows popup again on next visit
        onDismiss={dismiss} // Never shows popup again
        isStandaloneMode={isStandaloneMode}
        data={rb_signin}
      />
      {/* <LocalStorageDebug /> */}
    </div>
  ) : (
    <div className="flex justify-center items-center h-[50vh]">
      <Spinner />
    </div>
  );
};
export default SignIn;
